<template>
  <div
    :class="[
      'flex w-full flex-row gap-4 p-1 py-2',
      expanded ? 'items-start justify-start' : 'items-center justify-center'
    ]"
  >
    <div class="flex flex-col items-center">
      <AvatarWithRank
        :avatar-src="typeof profile.image === 'string' ? profile.image : undefined"
        :rank="profile.rank || 0"
        size="md"
        :avatar-alt="profile.name"
        badge-position="bottom-center"
        class="translate-y-[-0.25rem]"
      />
    </div>

    <div
      v-if="expanded"
      class="flex flex-col overflow-hidden whitespace-nowrap pt-2 transition-opacity duration-300 ease-in-out"
    >
      <span class="overflow-hidden text-ellipsis text-sm text-white">{{ profile.name }}</span>
      <span class="text-xs text-gray-500">{{ profile.tag }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { type Profile } from '../NavigationPaneComponent.vue'
import AvatarWithRank from '../../AvatarWithRank.vue'

export default defineComponent({
  name: 'NavigationPaneProfile',
  components: {
    AvatarWithRank
  },
  props: {
    profile: {
      type: Object as () => Profile,
      required: true,
      validator: (value: Profile) => {
        return typeof value.name === 'string' && typeof value.tag === 'string'
      }
    },
    expanded: {
      type: Boolean,
      default: false
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  }
})
</script>
